/**
 * Faces and the default icon set that ship with the app.
 * Uploaded faces and icon sets live in the site library, not here.
 */

/**
 * `preload` is the latin file behind the face's @font-face rule in
 * styles/globals.css; keep the two in step.
 */
export const BUILTIN_FACES = [
    {
        id: 'work-sans',
        label: 'Work Sans',
        css: "'Work Sans', 'Work Sans Fallback', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
        preload: '/fonts/work-sans-v8-latin.woff2',
        google: null,
        source: 'builtin',
    },
    {
        id: 'sansumi',
        label: 'Sansumi',
        css: "'Sansumi', 'Sansumi Fallback', system-ui, sans-serif",
        preload: '/fonts/sansumi-bold-v1.woff2',
        google: null,
        source: 'builtin',
    },
    {
        id: 'akzidenz',
        label: 'Akzidenz Grotesk',
        css: "'AkzidenzGrotesk', 'AkzidenzGrotesk Fallback', system-ui, sans-serif",
        preload: '/fonts/akzidenz-grotesk-v1.woff2',
        google: null,
        source: 'builtin',
    },
    {
        id: 'system',
        label: 'System UI',
        css: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
        google: null,
        source: 'builtin',
    },
    // Legacy catalog ids (kept for resolveFace fallback only). Not listed in
    // pickers — host via Library → Import Google Font instead.
    { id: 'inter', label: 'Inter', css: 'system-ui, sans-serif', google: 'Inter:wght@300;400;500;600;700', source: 'builtin' },
    { id: 'dm-sans', label: 'DM Sans', css: 'system-ui, sans-serif', google: 'DM+Sans:wght@300;400;500;700', source: 'builtin' },
    { id: 'space-grotesk', label: 'Space Grotesk', css: 'system-ui, sans-serif', google: 'Space+Grotesk:wght@300;400;500;700', source: 'builtin' },
    { id: 'playfair', label: 'Playfair Display', css: 'Georgia, serif', google: 'Playfair+Display:wght@400;500;600;700', source: 'builtin' },
    { id: 'cormorant', label: 'Cormorant Garamond', css: 'Georgia, serif', google: 'Cormorant+Garamond:wght@300;400;500;600', source: 'builtin' },
    { id: 'source-serif', label: 'Source Serif', css: 'Georgia, serif', google: 'Source+Serif+4:wght@300;400;500;600', source: 'builtin' },
    { id: 'georgia', label: 'Georgia', css: 'Georgia, "Times New Roman", serif', google: null, source: 'builtin' },
];

export const DEFAULT_FACE_ID = 'work-sans';

/** Glyphs drawn by the viewer's built-in icons. Custom sets replace these with file URLs. */
export const DEFAULT_ICON_SET = {
    id: 'default',
    label: 'Default',
    source: 'builtin',
    glyphs: {
        close: { builtin: 'close', label: 'Close' },
        'chevron-left': { builtin: 'chevron-left', label: 'Previous' },
        'chevron-right': { builtin: 'chevron-right', label: 'Next' },
        play: { builtin: 'play', label: 'Play' },
        pause: { builtin: 'pause', label: 'Pause' },
    },
};
